import React, { useEffect, useRef, useState, Suspense } from 'react'
import { Canvas, useLoader, useFrame } from '@react-three/fiber'
import { TextureLoader } from 'three/src/loaders/TextureLoader'
import * as THREE from 'three'

let normalFace, happyFace, delta, clock = new THREE.Clock(), timer = 0

window.clock = clock

function FaceScene() {
  normalFace = useLoader(TextureLoader, './assets/images/adriel.jpg')
  happyFace = useLoader(TextureLoader, './assets/images/happy-face.jpg')
  let [mapToUse, setMapToUse] = useState(normalFace),
   [usedMapName, setUsedMapName] = useState('normalFace')
  // This reference gives us direct access to the THREE.Mesh object
  const ref = useRef(),
   standardMaterialRef = useRef()
  useFrame((state, delta) => {
    (ref.current.rotation.y += 0.01)
    timer += delta
    // console.log(`timer`, timer)
    if (timer >= 6) {
      if (usedMapName == 'normalFace') {
        // setMapToUse(happyFace)
        standardMaterialRef.current.map = happyFace
        setUsedMapName('happyFace')
      } else {
        // setMapToUse(normalFace)
        standardMaterialRef.current.map = normalFace
        setUsedMapName('normalFace')
      }
      timer = 0
    }
    
  })

  return (
    <>
      <ambientLight intensity={.5} />
      <directionalLight />
      <mesh ref={ref}>
        <boxGeometry args={[3, 3, 3]} />
        <meshStandardMaterial ref={standardMaterialRef} map={mapToUse}/>
      </mesh>
    </>
  )
}

const RotatingCubeFace = () => {

  return (
    <Canvas>
       <Suspense fallback={null}>
        <FaceScene />
      </Suspense>
    </Canvas>
  )
}

export default RotatingCubeFace